import { render } from "./myCheckbox.vue?vue&type=template&id=c5ad5612&scoped=true"
import script from "./myCheckbox.vue?vue&type=script&lang=js"
export * from "./myCheckbox.vue?vue&type=script&lang=js"

import "./myCheckbox.vue?vue&type=style&index=0&id=c5ad5612&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5ad5612"]])

export default __exports__